import { gql } from "@apollo/client";

// One person's place on the ladder, the criteria written for them alone, and
// whether the viewer can edit those (an admin, or the person's manager).
export default gql`
  query getPersonCareer($organizationId: Int!, $userId: Int!) {
    user(userId: $userId) {
      id
      name
      avatar
      currentRoles {
        id
        title
        level
        careerTrack {
          id
          title
        }
      }
    }
    userCareerCriteria(organizationId: $organizationId, userId: $userId) {
      id
      content
      ordinal
    }
    userCareerCriteriaVersion(organizationId: $organizationId, userId: $userId)
    canEditUserCareerCriteria(organizationId: $organizationId, userId: $userId)
  }
`;
